


















































import {format} from "date-fns";
import Vue from "vue";
import {api} from "@/ts/constants";

export default Vue.extend({
    name: "Trash",
    components: {},
    data: () => ({
        trashItems: [] as any[],
        errorItems: [] as any[],

        api,
    }),
    async mounted() {
        let blocked = await this.$store.dispatch('apiRequest', {url: 'photos/blockedItems'});
        this.trashItems = blocked.filter((b: { reason: string; }) => b.reason === 'deleted');
        this.errorItems = blocked.filter((b: { reason: string; }) => b.reason === 'error');
        console.log(this.trashItems, this.errorItems);
    },
    methods: {
        async retry(item: any) {
            Vue.set(item, 'retrying', true);
            let result = await this.$store.dispatch('apiRequest', {
                url: 'photos/retryProcess',
                body: {filePath: item.filePath}
            });
            if (result.success === false) {
                this.$store.dispatch('addSnack', {text: 'Failed to process item again'});
            } else {
                this.$store.dispatch('addSnack', {
                    text: `Processed item successfully`,
                    toText: 'Visit',
                    to: `/photo/${result.id}`
                });
            }
            Vue.set(item, 'retrying', false);
        },
        async downloadItem(item: any) {
            Vue.set(item, 'downloading', true);
            try {
                let blob = await fetch(`${api}/photos/blocked/${item.id}`).then(resp => resp.blob());
                if (blob.type === 'text/html' && blob.size < 1000) {
                    this.$store.dispatch('addSnack', {text: "Item not found on server!"});
                    throw new Error("Not found");
                }
                console.log(blob);
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                let pathParts = item.filePath.split('/');
                a.download = pathParts[pathParts.length - 1];
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.warn("Download failed", e);
            } finally {
                Vue.set(item, 'downloading', false);
            }
        },
        errorLines(item: any) {
            return item?.error?.message?.split?.('\n') ?? [];
        },
        formatDate(dateString: string) {
            return format(new Date(dateString), 'H:mm:ss, eeee dd MMMM yyyy')
        },
    },
});
